import {
  getAssetGroupTreeList,
  getPointTreeList,
} from "@/api/cusApi/assets/category";
import { getDepartmentTree } from "@/api/department/tree";

import { filterTree, treeToFlat } from "@/utils/tools";
import { Message } from "element-ui";

const global = {
  namespaced: true,
  state: {
    isFirst: false, // 是否为首次获取全局共享数据
    // showAllTask: false, // 展示所有数据
    peopleCharge: [], // 经办人员 经办部门列表
    receivingUnit: [], // 收货单位/财务组织列表
    assetGroupTree: [], //分组信息树
    pointTree: [], //资产位置树
  },
  mutations: {
    SET_IS_FIRST: (state, payload) => {
      state.isFirst = payload;
    },
    // SET_SHOWALLTASK: (state, payload) => {
    //   state.showAllTask = payload;
    // },
    // (20)
    SET_PEOPLE_CHARGE: (state, payload) => {
      state.peopleCharge = payload;
    },
    // 全部财务组织列表   (12)
    SET_RECEIVING_UNIT: (state, payload) => {
      state.receivingUnit = payload;
    },

    //分组信息树 (12)
    SET_ASSET_TREE: (state, payload) => {
      state.assetGroupTree = payload;
    },

    // 资产位置树 (10)
    SET_POINT_TREE: (state, playload) => {
      state.pointTree = playload;
    },
  },

  actions: {
    // 获取全部经办部门
    getAllPeopleCharge({ commit }) {
      getDepartmentTree().then((res) => {
        if (res && res.success) {
          console.log("dialogFormData.attachDeptIdArray--->", res.data);
          let arr = res.data.map((item) => {
            return {
              ...item,
              id: String(item.id),
            };
          });
          commit("SET_PEOPLE_CHARGE", arr);
        } else {
          Message({
            type: "warning",
            message: res?.errMsg || "获取全部经办部门失败",
          });
        }
      });
    },

    // 获取全部收货单位/归属公司
    getAllReceivingUnit({ commit }) {
      getDepartmentTree().then((res) => {
        if (res && res.success) {
          commit("SET_RECEIVING_UNIT", treeToFlat(res.data));
        }
      });
      // getFinaorgList().then((res) => {
      //   if (res && res.success) {
      //     commit("SET_RECEIVING_UNIT", res.data)
      //   } else {
      //     Message({
      //       type: "warning",
      //       message: res?.errMsg || "获取全部归属单位失败"
      //     })
      //   }
      // })
    },

    // 分组信息树
    getAssetGroupTreeList({ commit }) {
      getAssetGroupTreeList().then((res) => {
        console.log(res, "res.....");
        if (res && res.success) {
          commit("SET_ASSET_TREE", filterTree(res.data));
        } else {
          Message({
            type: "warning",
            message: res?.errMsg || "获取全部分组信息列表失败",
          });
        }
      });
    },

    // 资产位置树
    getPointTree({ commit }) {
      getPointTreeList().then((res) => {
        if (res && res.success) {
          commit("SET_POINT_TREE", filterTree(res.data));
        } else {
          Message({
            type: "warning",
            message: res?.errMsg || "获取资产位置列表失败",
          });
        }
      });
    },

    getAllGlobalData({ dispatch }) {
      dispatch("getAllPeopleCharge");
      dispatch("getAllReceivingUnit");
      dispatch("getAssetGroupTreeList");
      dispatch("getPointTree");
    },
  },
};

export default global;
